import Axios from './axios'
/**
 * @interface loginParams -登录参数
 * @property {string} loginName -用户名
 * @property {string} password -用户密码
 */
// 封装User类型的接口方法
export class UploadService {
  /**
   * @description 查询User的信息
   * @param {number} teamId - 所要查询的团队ID
   * @return {HttpResponse} result
   */
  // 上传图片(只上传不记录)
  // eslint-disable-next-line require-await
  static async base64image(data: any) {
    return Axios('/file/image', {
      method: 'post',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      transformRequest:[(data) => {
        let ret = ''
        for (const it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async previewUpdate(data: any) {
    return Axios('/user/ppt/uploadUpdate', {
      method: 'post',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      transformRequest:[(data) => {
        let ret = ''
        for (const it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async userMaterial(data: any) {
    return Axios('/file/save/', {
      method: 'post',
      data,
    })
  }

  // eslint-disable-next-line require-await
  static async userMaterialInsert(data: any) {
    return Axios('/file/insert/', {
      method: 'post',
      data,
    })
  }
  // eslint-disable-next-line require-await
  static async uploadSvg(data: any) {
    return Axios('/material/change_svg_code', {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      transformRequest: [function (data) {
        return data
      }],
      method: 'post',
      data,
    })
  }


}
